import _ from 'underscore'
import JoinSchoolViewTemplate from '../templates/join-school.tpl'
import FormView from './form'
import messages from '../messages'
import Alert from '../helpers/alert'
import Backbone from 'backbone'

const JoinSchoolView = FormView.extend({
    events: {
        'click .submit': 'joinSchool',
    },
    initialize() {
        this.template = _.template(JoinSchoolViewTemplate)
    },
    joinSchool() {
        // set the school changes
        const pin = this.$el.find('#pin').val()

        new Promise((resolve, reject) => {
            // checks if name is blank
            if (pin.trim() === '') {
                reject(messages.MSG_PIN_BLANK)
            }
            resolve()
        })
            .then(() => this.model.get('school').join(pin))
            .then((school_name) => {
                // join requested

                // force load the menu view
                Backbone.history.navigate('', {trigger: true})

                // a message is then printed with the school name
                if (this.model.get('type').get('name') === 'teacher') {
                    Alert(messages.MSG_JOIN_REQUEST + school_name)
                } else {
                    Alert(messages.MSG_STUDENT_JOIN_REQUEST + school_name)
                }
            })
            .catch(Alert)
    }
})

export default JoinSchoolView
